import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Selection from '~app/components/Selection';
import { setAppVersion } from '~app/actions/app';
import { getBrowser } from '~app/utils/getBrowser';
import { useT, useResources } from '~app/BundleProvider';

const preferredBrowsers = ["Chrome", "Firefox"];

const Page1 = ({ 
  direction,
  handleStartIntro,
  handleSkipIntro,
  setAppVersion,
  version,
  mainRef,
}) => {
  const t = useT();
  const r = useResources();
  return (
    <main role="main" className={`intro-page page-1 ${direction}`}>
      {!preferredBrowsers.includes(getBrowser()) &&
        <div className="page-1__browser-warning">
          <img 
            className="page-1__browser-warning-icon"
            src={require('~app/resources/images/icons/caution.svg')} 
            alt={t("caution")}
          />
          {t("browser-functionality")}
        </div>
      }
    
      <img 
        src={require("~app/resources/images/flow-icon.svg")} 
        alt={t("how-science-works-logo")}
        className="flow-icon" 
      />

      <img 
        src={r("header-title.svg")} 
        alt={t("how-science-works")}
        className="intro__title" 
      />

      <div
        ref={mainRef}
        tabIndex="-1"
        className="scalable"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          position: "absolute",
          top: "30vh",
          height: "50vh",
          width: "100%",
        }}
      >

        <h1 style={{marginBottom: 0}}>
          {t("choose-framework")} 
        </h1>

        <div className="button-group">
          <Selection 
            onClick={() => setAppVersion("standard")} 
            className={`${version === "standard" && 'selected'} version-select`}
            ariaLabel={t("standard-label")}
          >
            {t("standard")}
          </Selection>

          <Selection 
            onClick={() => setAppVersion("simple")}
            className={`${version === "simple" && 'selected'} version-select`}
            ariaLabel={t("simplified-label")}
          > 
            {t("simplified")}
          </Selection>
        </div>

        <h1 style={{marginBottom: 0}}>{t("get-started")}</h1>

        <div className="button-group">
          <Selection
            onClick={handleStartIntro}
            ariaLabel={t("intro-label")}
          >
            {t("intro")}
          </Selection>

          <Selection
            onClick={handleSkipIntro}
            ariaLabel={t("skip-intro-label")}
          >
            {t("skip-intro")}
          </Selection>
        </div>

      </div>

    </main>
  );
};

Page1.propTypes = {
  direction: PropTypes.string.isRequired,
  handleStartIntro: PropTypes.func.isRequired,
  handleSkipIntro: PropTypes.func.isRequired,
  setAppVersion: PropTypes.func.isRequired,
  version: PropTypes.string.isRequired,
  mainRef: PropTypes.func.isRequired,
};

const mapStateToProps = ({ app }) => ({ version: app.version });

export default connect(mapStateToProps, { setAppVersion })(Page1);



// WEBPACK FOOTER //
// ./src/pages/intro/Page1.js